import React from 'react';
import Package from './package';

function index(props) {
	return <Package {...props} />;
}

export default index;
